const MAPPED_GATES = {
  land: [
    {
      label: "Bo Y Landport",
      "value": "Bo Y Landport"
    },
    {
      label: "Cau Treo Landport",
      "value": "Cau Treo Landport"
    },
    {
      label: "Cha Lo Landport",
      "value": "Cha Lo Landport"
    },
    {
      label: "Ha Tien Landport",
      "value": "Ha Tien Landport"
    },
    {
      label: "Huu Nghi Landport",
      "value": "Huu Nghi Landport"
    },
    {
      label: "La Lay Landport",
      "value": "La Lay Landport"
    },
    {
      label: "Lao Bao Landport",
      "value": "Lao Bao Landport"
    },
    {
      label: "Lao Cai Landport",
      "value": "Lao Cai Landport"
    },
    {
      label: "Moc Bai Landport",
      "value": "Moc Bai Landport"
    },
    {
      label: "Mong Cai Landport",
      "value": "Mong Cai Landport"
    },
    {
      label: "Na Meo Landport",
      "value": "Na Meo Landport"
    },
    {
      label: "Nam Can Landport",
      "value": "Nam Can Landport"
    },
    {
      label: "Tay Trang Landport",
      "value": "Tay Trang Landport"
    },
    {
      label: "Tinh Bien Landport",
      "value": "Tinh Bien Landport"
    },
    {
      label: "Vinh Xuong Landport",
      "value": "Vinh Xuong Landport"
    },
    {
      label: "Xa Mat Landport",
      "value": "Xa Mat Landport"
    }
  ],
  sea: [
    {
      label: "Cam Pha Seaport",
      "value": "Cam Pha Seaport"
    },
    {
      label: "Chan May Seaport",
      "value": "Chan May Seaport"
    },
    {
      label: "Da Nang Seaport",
      "value": "Da Nang Seaport"
    },
    {
      label: "Dung Quat Seaport",
      "value": "Dung Quat Seaport"
    },
    {
      label: "Duong Dong Seaport",
      "value": "Duong Dong Seaport"
    },
    {
      label: "Hai Phong Seaport",
      "value": "Hai Phong Seaport"
    },
    {
      label: "Ho Chi Minh City Seaport",
      "value": "Ho Chi Minh City Seaport"
    },
    {
      label: "Hon Gai Seaport",
      "value": "Hon Gai Seaport"
    },
    {
      label: "Nghi Son Seaport",
      "value": "Nghi Son Seaport"
    },
    {
      label: "Nha Trang Seaport",
      "value": "Nha Trang Seaport"
    },
    {
      label: "Quy Nhon Seaport",
      "value": "Quy Nhon Seaport"
    },
    {
      label: "Vung Ang Seaport",
      "value": "Vung Ang Seaport"
    },
    {
      label: "Vung Tau Seaport",
      "value": "Vung Tau Seaport"
    }
  ],
  air: [
    {
      label: "Cam Ranh Int Airport (Khanh Hoa)",
      "value": "Cam Ranh Int Airport (Khanh Hoa)"
    },
    {
      label: "Can Tho International Airport",
      "value": "Can Tho International Airport"
    },
    {
      label: "Cat Bi Int Airport (Hai Phong)",
      "value": "Cat Bi Int Airport (Hai Phong)"
    },
    {
      label: "Da Nang International Airport",
      "value": "Da Nang International Airport"
    },
    {
      label: "Dong Hoi Int Airport (Quang Binh)",
      "value": "Dong Hoi Int Airport (Quang Binh)"
    },
    {
      label: "Lien Khuong International Airport",
      "value": "Lien Khuong International Airport"
    },
    {
      label: "Noi Bai Int Airport",
      "value": "Noi Bai Int Airport"
    },
    {
      label: "Phu Bai Int Airport",
      "value": "Phu Bai Int Airport"
    },
    {
      label: "Phu Cat Int Airport",
      "value": "Phu Cat Int Airport"
    },
    {
      label: "Phu Quoc International Airport",
      "value": "Phu Quoc International Airport"
    },
    {
      label: "Tan Son Nhat Int Airport (Ho Chi Minh City)",
      "value": "Tan Son Nhat Int Airport (Ho Chi Minh City)"
    },
    {
      label: "Van Don Int Airport",
      "value": "Van Don Int Airport"
    }
  ]
}

const GATE_FIELD = {
  type: "buttons",
  props: {
    options: [
      {
        icon: "icon-air",
        label: "Air",
        value: "air"
      },
      {
        icon: "icon-sea",
        label: "Sea",
        value: "sea"
      },
      {
        icon: "icon-land",
        label: "Land",
        value: "land"
      }
    ]
  }
}

export const VN_FIELDS = {
  law_violation: {
    answer: {
      type: "yes-no-buttons"
    },
    list: {
      type: "multiple",
      fieldArray: {
        fieldGroup: [
          {
            key: "act",
            type: "name-field",
            props: {
              "label": "Act of Violation",
              required: true
            },
            className: "gwc-form__field gwc-form__field--grow"
          },
          {
            key: "date",
            type: "datepicker",
            props: {
              "view": "multi-year",
              "after": [
                {
                  "date": "01/01/1800",
                  "message": "Date of Birth must be after 01/01/1800"
                }
              ],
              "label": "Date of Violation",
              "before": [
                {
                  "date": "now",
                  "message": "Date can't be in the future"
                }
              ],
              required: true
            },
            className: "gwc-form__field gwc-form__field--grow"
          },
          {
            key: "sanction",
            type: "name-field",
            props: {
              "label": "Form of Sanction",
              required: true
            },
            className: "gwc-form__field gwc-form__field--grow"
          },
          {
            key: "authority",
            type: "input",
            props: {
              "label": "Authority imposing the sanction",
              required: true,
              maxLength: 255
            },
            className: "gwc-form__field gwc-form__field--grow"
          }
        ]
      },
      defaultValue: [
        null
      ]
    }
  },
  relatives: {
    answer: {
      type: "yes-no-buttons"
    },
    list: {
      type: "multiple",
      fieldArray: {
        fieldGroup: [
          {
            fieldGroup: [
              {
                key: "first_name",
                type: "name-field",
                props: {
                  label: "First Name",
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "last_name",
                type: "name-field",
                props: {
                  label: "Last Name",
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              }
            ],
            fieldGroupClassName: "gwc-form__field-group"
          },
          {
            key: "relationship",
            type: "input",
            props: {
              label: "Relationship",
              required: true,
              maxLength: 255
            },
            className: "gwc-form__field gwc-form__field--grow gwc-form__field--no-max"
          },
          {
            fieldGroup: [
              {
                key: "date_of_birth",
                type: "datepicker",
                props: {
                  view: "multi-year",
                  after: [
                    {
                      date: "01/01/1800",
                      message: "Date of Birth must be after 01/01/1800"
                    }
                  ],
                  label: "Date of Birth",
                  before: [
                    {
                      date: "now",
                      message: "Date can't be in the future"
                    }
                  ],
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "nationality",
                type: "country-autocomplete",
                props: {
                  label: "Nationality",
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              }
            ],
            fieldGroupClassName: "gwc-form__field-group"
          },
          {
            key: "address",
            type: "input",
            props: {
              label: "Address",
              required: true,
              maxLength: 255
            },
            className: "gwc-form__field gwc-form__field--grow gwc-form__field--no-max"
          }
        ]
      },
      defaultValue: [
        null
      ]
    }
  },
  other_passport_entries: {
    answer: {
      type: "yes-no-buttons"
    },
    list: {
      type: "multiple",
      fieldArray: {
        fieldGroup: [
          {
            fieldGroup: [
              {
                key: "first_name",
                type: "name-field",
                props: {
                  label: "First Name",
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "middle_name",
                type: "name-field",
                props: {
                  label: "Middle Name",
                  required: false
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "last_name",
                type: "name-field",
                props: {
                  label: "Last Name",
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              }
            ],
            fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
          },
          {
            key: "date_of_birth",
            type: "datepicker",
            props: {
              view: "multi-year",
              after: [
                {
                  date: "01/01/1800",
                  message: "Date of Birth must be after 01/01/1800"
                }
              ],
              label: "Date of Birth",
              before: [
                {
                  date: "now",
                  message: "Date can't be in the future"
                }
              ],
              required: true
            },
            className: "gwc-form__field gwc-form__field--grow"
          },
          {
            fieldGroup: [
              {
                key: "nationality",
                type: "country-autocomplete",
                label: "Nationality",
                props: {
                  label: "Nationality"
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "passport.number",
                type: "input",
                props: {
                  label: "Passport Number",
                  required: true,
                  maxLength: 9
                },
                className: "gwc-form__field gwc-form__field--grow"
              }
            ],
            fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
          }
        ]
      },
      defaultValue: [
        null
      ]
    }
  }
}

export const VN_APPLICATION_FIELDS = {
  insurance: {
    answer: {
      type: "yes-no-buttons"
    },
    name: {
      type: "input",
      props: {
        label: "Insurance Company Name",
        maxLength: 100
      }
    }
  },
  expenses: {
    payment_method: {
      type: "mapped-select",
      props: {
        label: "Payment Method",
        parentKey: "application.vn.expenses.covered_by",
        mappedOptions: {
          Personal: [
            {
              label: "Cash",
              value: "Cash"
            },
            {
              label: "Credit Card",
              value: "Credit card"
            },
            {
              label: "Traveler's Checks",
              value: "Traveller's cheques"
            }
          ],
          Company: [
            {
              label: "Cash",
              value: "Cash"
            },
            {
              label: "Credit Card",
              value: "Credit card"
            }
          ]
        }
      }
    },
    amount: {
      type: "input",
      props: {
        min: 0,
        type: "number",
        label: "Amount in USD"
      }
    },
    covered_by: {
      type: "select",
      props: {
        label: "Covered by",
        options: [
          {
            label: "Self",
            value: "Personal"
          },
          {
            label: "Company",
            value: "Company"
          }
        ]
      }
    },
    company_name: {
      key: "application.expenses.company_name",
      type: "input",
      props: {
        label: "Company Name",
        maxLength: 100
      }
    },
    company_phone: {
      type: "input",
      props: {
        label: "Company Phone",
        maxLength: 50
      }
    },
    company_address: {
      type: "input",
      props: {
        label: "Company Address",
        maxLength: 255
      }
    },
  },
  visited_vietnam: {
    answer: {
      type: "yes-no-buttons"
    },
    list: {
      key: "application.vn.visited_vietnam.list",
      type: "multiple",
      fieldArray: {
        fieldGroup: [
          {
            key: "reason",
            type: "input",
            props: {
              label: "Reason for visit",
              required: true,
              maxLength: 255
            },
            className: "gwc-form__field gwc-form__field--grow gwc-form__field--no-max"
          },
          {
            fieldGroup: [
              {
                key: "from",
                type: "datepicker",
                props: {
                  "after": [
                    {
                      "date": "01/01/2024",
                      "message": "Date of Birth must be after 01/01/2024"
                    }
                  ],
                  label: "From",
                  "before": [
                    {
                      "date": "now",
                      "message": "Date can't be in the future"
                    }
                  ],
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "to",
                type: "datepicker",
                props: {
                  "after": [
                    {
                      "date": "01/01/2024",
                      "message": "Date of Birth must be after 01/01/2024"
                    }
                  ],
                  label: "To",
                  "before": [
                    {
                      "date": "now",
                      "message": "Date can't be in the future"
                    }
                  ],
                  required: true
                },
                className: "gwc-form__field gwc-form__field--grow"
              }
            ],
            fieldGroupClassName: "gwc-form__field-group"
          }
        ]
      },
      defaultValue: [
        null
      ]
    }
  },
  contact: {
    answer: {
      type: "yes-no-buttons"
    },
    list: {
      type: "multiple",
      fieldArray: {
        fieldGroup: [
          {
            key: "name",
            type: "input",
            props: {
              label: "Name of the agency, organization or individual",
              required: true,
              maxLength: 100
            },
            className: "gwc-form__field gwc-form__field--grow gwc-form__field--no-max"
          },
          {
            fieldGroup: [
              {
                key: "phone",
                type: "input",
                props: {
                  label: "Phone number",
                  required: true,
                  maxLength: 50
                },
                className: "gwc-form__field gwc-form__field--grow"
              },
              {
                key: "purpose",
                type: "input",
                props: {
                  label: "Reason for contact",
                  required: true,
                  maxLength: 255
                },
                className: "gwc-form__field gwc-form__field--grow"
              }
            ],
            fieldGroupClassName: "gwc-form__field-group"
          },
          {
            key: "address",
            type: "input",
            props: {
              label: "Address",
              required: true,
              maxLength: 255
            },
            className: "gwc-form__field gwc-form__field--grow gwc-form__field--no-max"
          }
        ]
      },
      defaultValue: [
        null
      ]
    }
  },
  address: {
    address_1: {
      type: "input",
      props: {
        label: "Street Address",
        required: true
      }
    },
    city: {
      type: "vn-province"
    },
    ward: {
      type: "vn-ward",
    }
  },
  entry_gate: GATE_FIELD,
  entry_gate_detail: {
    type: "mapped-select",
    props: {
      label: "Entry Border Gate",
      parentKey: "application.vn.entry_gate",
      mappedOptions: MAPPED_GATES
    }
  },
  exit_gate: GATE_FIELD,
  exit_gate_detail: {
    type: "mapped-select",
    props: {
      label: "Exit Border Gate",
      parentKey: "application.vn.exit_gate",
      mappedOptions: MAPPED_GATES
    }
  },
  purpose: {
    type: "select",
    props: {
      label: "Purpose of Visit",
      options: [
        {
          label: "Tourism",
          value: "Tourist"
        },
        {
          label: "Business",
          value: "Business"
        },
        {
          label: "Work",
          value: "Working"
        },
        {
          label: "Crew",
          value: "Crew"
        },
        {
          label: "Visiting Family",
          value: "Visiting relatives"
        }
      ]
    }
  }
}